__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "HtemApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hero/federation-library", "1.0.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(757)]).then(() => (() => (__webpack_require__(5757))))));
			register("@hero/hero-auth-app", "1.6.0", () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(914), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(3215))))));
			register("@hero/hero-data-repo-app", "1.7.0", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(914), __webpack_require__.e(467)]).then(() => (() => (__webpack_require__(7154))))));
			register("@hero/hero-ml-model-registry-app", "1.2.0", () => (Promise.all([__webpack_require__.e(902), __webpack_require__.e(914), __webpack_require__.e(86)]).then(() => (() => (__webpack_require__(4902))))));
			register("@hero/hero-notifications-app", "1.3.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(342)]).then(() => (() => (__webpack_require__(7961))))));
			register("@hero/hero-platform-ui-app", "0.13.0", () => (Promise.all([__webpack_require__.e(641), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(9641))))));
			register("@hero/hero-sdk", "0.10.1", () => (Promise.all([__webpack_require__.e(83), __webpack_require__.e(499)]).then(() => (() => (__webpack_require__(8499))))));
			register("@hero/hero-search-app", "1.4.4", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(441)]).then(() => (() => (__webpack_require__(3441))))));
			register("@hero/hero-task-engine-app", "1.6.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(563)]).then(() => (() => (__webpack_require__(2563))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(53), __webpack_require__.e(12), __webpack_require__.e(886), __webpack_require__.e(890), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833)]).then(() => (() => (__webpack_require__(5890))))));
			register("@mui/system", "5.18.0", () => (Promise.all([__webpack_require__.e(53), __webpack_require__.e(886), __webpack_require__.e(367), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(7367))))));
			register("@tanstack/react-query", "5.101.0", () => (Promise.all([__webpack_require__.e(980), __webpack_require__.e(914), __webpack_require__.e(705)]).then(() => (() => (__webpack_require__(8980))))));
			register("jotai", "2.20.1", () => (Promise.all([__webpack_require__.e(35), __webpack_require__.e(914), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(5076))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};